import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import AppHeader from "@/components/AppHeader";
import Home from "@/pages/Home";
import Auth from "@/pages/Auth";
import Moodscape from "@/pages/Moodscape";
import Insights from "@/pages/Insights";
import { Toaster } from "@/components/ui/sonner";

function Protected({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <div className="pt-24 text-center text-sm text-[var(--text-muted)]">Loading…</div>;
  if (user === false) return <Navigate to="/auth" state={{ from: loc.pathname }} replace />;
  return children;
}

function Layout() {
  return (
    <>
      <AppHeader />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/moodscape" element={<Protected><Moodscape /></Protected>} />
        <Route path="/feedback" element={<Protected><Insights /></Protected>} />
        <Route path="/auth" element={<Auth />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Layout />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
